var map = {
	"./Alarm (警报)@2x.png": "607e",
	"./Attention (注意)@2x.png": "a792",
	"./Down.png": "b3d1",
	"./Keyboard.png": "0d63",
	"./Tips-one (提示)@2x.png": "655b",
	"./Volume-notice.png": "cb63",
	"./aiIcon.png": "43c4",
	"./ai_icon.png": "a5a7",
	"./icon_2.png": "8d9f",
	"./pause.png": "25a7",
	"./play.png": "30ec",
	"./replay.png": "5ce2",
	"./send.png": "798a",
	"./up.png": "307a",
	"./关闭声音.png": "102d",
	"./图标-AI小助手2.png": "8cc1",
	"./图标-AI小助手@2x.png": "79e8",
	"./图标—日光浴@2x.png": "f480",
	"./图标—睡眠@2x.png": "00f5",
	"./图标—运动@2x.png": "d4a0",
	"./语音.png": "8d0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c05";